/**
 * A Job-less Visit whose Job would lack a price book, owner or contact (WBS-12662), or carry a price book
 * outside its dates (WBS-12695), says so before anyone tries; one whose automatic Job creation parked says
 * why (WBS-12696).
 */
import { VisitBrowseRow, visitJobCreationFailedText, visitJobReadinessSentence } from '@jms/model';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

export const visitJobReadinessTag = defineConditionalTag<VisitBrowseRow>(row => {

  // A stamper failure already names its own reason through the construction tag; one tag per problem.
  if (!row || row.job?._id || row.jobCreation) return null;
  if (row.jobReadinessDetail?.length) return { label: 'Can\'t create job', tone: 'warning', tooltip: visitJobReadinessSentence(row.jobReadinessDetail, 'Jobs need') };
  // The parked message may be gone (cancelled, expired); the reason recorded on the Visit outlives it.
  if (row.jobCreationFailure?.message) return { label: 'Can\'t create job', tone: 'warning', tooltip: visitJobCreationFailedText(row.jobCreationFailure.message) };
  return null;
});
